export function languageFromCulture(culture: string): string {
    return culture.split('-')[0].toLowerCase();
}



// WEBPACK FOOTER //
// ./src/utils/languageFromCulture.ts